<script>
export default {
  name: 'CiResourceHeaderSkeletonLoader',
};
</script>

<template>
  <div class="gl-flex">
    <div class="gl-animate-skeleton-loader gl-h-11 gl-w-11 gl-rounded-base"></div>
    <div class="gl-flex gl-flex-col gl-items-center gl-justify-center gl-pl-4">
      <div class="gl-animate-skeleton-loader gl-mb-3 gl-h-4 gl-w-20 gl-rounded-base"></div>
      <div class="gl-animate-skeleton-loader gl-h-4 gl-w-20 gl-rounded-base"></div>
    </div>
  </div>
</template>
